import { getUrlLocaleCode } from '~/lang/locales'
import { keysToCamel } from '~/utility/toCamel'
import { FlatPage, flatPageSchema } from './schema'

export class FlatPagesRepositoryFetch {
  async get(
    pageURL: string,
    langCode: string,
  ): Promise<FlatPage | { location: string }> {
    const responseData = await $fetch(this.getUrl(pageURL, langCode), {
      timeout: 30000,
    })
    if (typeof responseData.location !== 'undefined') {
      return responseData
    }
    const data = flatPageSchema.parse(keysToCamel(responseData))
    // pageURL we request is the same as current page
    data.content = this.fixHashLinks(pageURL, data.content)
    return data
  }

  private fixHashLinks(pageURL: string, content: string) {
    return content.replaceAll('href="#', `href="${pageURL}#`)
  }

  private getUrl(pageURL: string, langCode: string): string {
    const urlCode = getUrlLocaleCode(langCode)
    const prefix = urlCode ? `${urlCode}/` : ''
    return `/_/fallback/${prefix}_/static-pages/ajax/?url=${pageURL.replace(
      prefix,
      '',
    )}`
  }
}
